const STORAGE_KEY = 'dutchie-agent:session';

export type Session = {
  SessionId: string;
  UserId: number;
  LocId: number;
  LspId: number;
  Email: string | null;
};

let session: Session | null = null;

// Hydrate from sessionStorage on module load (survives HMR)
try {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (stored) {
    session = JSON.parse(stored);
  }
} catch {
  // SSR or storage unavailable — ignore
}

export function getSession(): Session | null {
  return session;
}

export function setSession(s: Session): void {
  session = s;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(s));
  } catch {
    // storage unavailable — in-memory only
  }
}

export function clearSession(): void {
  session = null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
